<template>
  <v-app>
    <update-alert />
    <router-view />

    <!--
      Popup global de mensagens da equipe.
      Fica FORA do <router-view>, então sobrevive à troca de telas.
    -->
    <chat-incoming-popup v-if="showChat" />

    <!-- Compositor: também global, abre a partir do popup em qualquer tela -->
    <chat-composer v-if="showChat" />
  </v-app>
</template>

<script>
import UpdateAlert from "./templates/Components/UpdateAlert.vue";
import ChatIncomingPopup from "./templates/Chat/ChatIncomingPopup.vue";
import ChatComposer from "./templates/Chat/ChatComposer.vue";

import chatService from "./services/chatService";

/**
 * Rotas onde o chat NÃO aparece: login e páginas de impressão/validação
 * pública. "sign-in" e "buy-print" vieram da NavBar.
 * COMPLETAR com os nomes reais das demais rotas de impressão/públicas,
 * ou marcar a rota com  meta: { hideChat: true }  no arquivo de rotas.
 */
const ROUTES_WITHOUT_CHAT = ["sign-in", "buy-print"];

export default {
  name: "App",

  components: { UpdateAlert, ChatIncomingPopup, ChatComposer },

  computed: {
    showChat() {
      const route = this.$route || {};
      if (route.meta && route.meta.hideChat) return false;
      return !ROUTES_WITHOUT_CHAT.includes(route.name);
    },
  },

  watch: {
    // A cada troca de rota: liga o serviço após o login, desliga após logout
    $route: {
      immediate: true,
      handler() {
        if (this.showChat) chatService.sync();
        else chatService.stop();
      },
    },

    // Caiu para offline: para. Voltou: retoma.
    "$store.state.online"() {
      if (this.showChat) chatService.sync();
    },
  },

  beforeDestroy() {
    chatService.stop();
  },
};
</script>